// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"ece7f898d6da01a6","531":"92e4a87980b34075"}[chunkId] + ".css";
};